import React, { useEffect, useState } from 'react';

/**
 * Seçili parçalara tek brüt fiyat uygulama.
 */
export default function ParcaBulkFiyatModal({
  isOpen,
  selectedCount = 0,
  confirmBusy = false,
  onClose,
  onConfirm,
}) {
  const [fiyat, setFiyat] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setFiyat('');
      setError('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (confirmBusy) return;
    const raw = String(fiyat || '').trim();
    if (raw === '') {
      setError('Brüt fiyat girin.');
      return;
    }
    const n = Number(raw.replace(',', '.'));
    if (!Number.isFinite(n) || n < 0) {
      setError('Brüt fiyat 0 veya daha büyük bir sayı olmalıdır.');
      return;
    }
    setError('');
    onConfirm(n);
  };

  return (
    <div
      className="modal-overlay parca-bulk-foto-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="parca-bulk-fiyat-title"
      onClick={(e) => {
        if (confirmBusy) return;
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="modal-content parca-bulk-foto-modal parca-bulk-fiyat-modal" onClick={(e) => e.stopPropagation()}>
        <div className="parca-bulk-foto-modal__header parca-bulk-fiyat-modal__header">
          <div className="parca-bulk-foto-modal__head-icon parca-bulk-fiyat-modal__head-icon" aria-hidden>
            <i className="fas fa-lira-sign" />
          </div>
          <div className="parca-bulk-foto-modal__head-text">
            <h2 id="parca-bulk-fiyat-title">Seçilenlere fiyat ekle/düzenle</h2>
            <p className="parca-bulk-foto-modal__subtitle">
              {selectedCount} parçaya uygulanacak
            </p>
          </div>
          <button
            type="button"
            className="close-btn parca-bulk-foto-modal__close"
            onClick={onClose}
            aria-label="Kapat"
            disabled={confirmBusy}
          >
            <i className="fas fa-times" />
          </button>
        </div>

        <form className="parca-bulk-fiyat-modal__form" onSubmit={handleSubmit}>
          <div className="parca-bulk-foto-modal__body">
            {error ? <p className="parca-bulk-fiyat-modal__error">{error}</p> : null}
            <label className="parca-bulk-fiyat-modal__field">
              <span>Brüt fiyat (₺)</span>
              <input
                type="text"
                inputMode="decimal"
                value={fiyat}
                onChange={(e) => setFiyat(e.target.value)}
                placeholder="0"
                disabled={confirmBusy}
                autoFocus
              />
            </label>
          </div>

          <div className="parca-bulk-foto-modal__footer">
            <button
              type="button"
              className="secondary-btn"
              disabled={confirmBusy}
              onClick={onClose}
            >
              İptal
            </button>
            <button
              type="submit"
              className="primary-btn"
              disabled={confirmBusy}
            >
              {confirmBusy ? (
                <>
                  <i className="fas fa-spinner fa-spin" aria-hidden />
                  Uygulanıyor…
                </>
              ) : (
                <>
                  <i className="fas fa-check" aria-hidden />
                  Uygula
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
